import React, { useState } from "react";
import styles from "./ExcludePathsManager.module.css";

const ExcludePathsManager = ({ setBotContent, botContent }) => {
  console.log("ExcludePathsManager botContent:", JSON.stringify(botContent));

  const [newPath, setNewPath] = useState("");

  // Toggle handler for dont_show_chat_box_at_logout
  const handleDontShowChatBoxToggle = () => {
    setBotContent((prev) => ({
      ...prev,
      dont_show_chat_box_at_logout: !prev.dont_show_chat_box_at_logout,
    }));
  };

  // Add a new exclude path
  const handleAddPath = () => {
    if (!newPath.trim()) return;

    const currentPaths = botContent.exclude_paths || [];
    // Avoid duplicates
    if (!currentPaths.includes(newPath.trim())) {
      setBotContent((prev) => ({
        ...prev,
        exclude_paths: [...(prev.exclude_paths || []), newPath.trim()],
      }));
      setNewPath("");
    }
  };

  // Remove an exclude path
  const handleRemovePath = (pathToRemove) => {
    setBotContent((prev) => ({
      ...prev,
      exclude_paths: (prev.exclude_paths || []).filter(
        (path) => path !== pathToRemove,
      ),
    }));
  };

  // Handle key press in input field
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAddPath();
    }
  };

  return (
    <div className={styles.wrap_path_settings}>
      {/* dont_show_chat_box_at_logout Toggle */}
      <div className={styles.controlGroup}>
        <label className={styles.controlLabel}>
          <div>
            <span className={styles.labelText}>Hide Chat Box on Logout</span>
            <p className={styles.helperText}>
              {botContent.dont_show_chat_box_at_logout
                ? "Chat box will be hidden when users are logged out"
                : "Chat box will remain visible even when users are logged out"}
            </p>
          </div>
          <div className={styles.toggleContainer}>
            <span className={styles.toggleLabel}>
              {botContent.dont_show_chat_box_at_logout ? "Enabled" : "Disabled"}
            </span>
            <div
              className={`${styles.toggleSwitch} ${botContent.dont_show_chat_box_at_logout ? styles.toggleOn : styles.toggleOff}`}
              onClick={handleDontShowChatBoxToggle}
            >
              <div className={styles.toggleSlider}></div>
            </div>
          </div>
        </label>
      </div>

      {/* Exclude Paths Section */}
      <div className={styles.pathsSection}>
        <h3 className={styles.sectionTitle}>Exclude Paths</h3>
        <p className={styles.sectionDescription}>
          Add paths where the chat widget should not appear. Example: /admin,
          /dashboard, /settings/profile
        </p>

        {/* Input for new path */}
        <div className={styles.inputGroup}>
          <input
            type="text"
            className={styles.pathInput}
            placeholder="Enter path to exclude (e.g., /admin)"
            value={newPath}
            onChange={(e) => setNewPath(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button
            className={styles.addButton}
            onClick={handleAddPath}
            disabled={!newPath.trim()}
          >
            Add Path
          </button>
        </div>

        {/* List of excluded paths */}
        {(botContent.exclude_paths || []).length > 0 ? (
          <div className={styles.pathsList}>
            <h4 className={styles.listTitle}>Excluded Paths:</h4>
            <ul className={styles.pathItems}>
              {(botContent.exclude_paths || []).map((path, index) => (
                <li key={index} className={styles.pathItem}>
                  <span className={styles.pathText}>{path}</span>
                  <button
                    className={styles.removeButton}
                    onClick={() => handleRemovePath(path)}
                    title="Remove path"
                  >
                    ✕
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className={styles.emptyState}>
            <p>No paths excluded. The chat widget will appear on all pages.</p>
          </div>
        )}

        {/* Helper text for exclude paths */}
        <div className={styles.helperBox}>
          <p className={styles.helperBoxTitle}>ℹ️ How it works:</p>
          <ul className={styles.helperBoxList}>
            <li>Paths are matched exactly against the current URL pathname</li>
            <li>Example: "/admin" will match "https://yoursite.com/admin"</li>
            <li>Add multiple paths to exclude chat from different sections</li>
            <li>Changes require a page refresh to take effect</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ExcludePathsManager;
